import { render, staticRenderFns } from "./boardTopFixStyle.vue?vue&type=template&id=6d5596fd&scoped=true&"
import script from "./boardTopFixStyle.vue?vue&type=script&lang=js&"
export * from "./boardTopFixStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5596fd",
  null
  
)

export default component.exports